import { useParams } from 'react-router-dom';

import { getTextWithLearnLangInterpolation } from 'src/viewLayer/components/shared/TextWithInterpolation/interpolate';

// This can later be extended to use `getTextWithInterpolation` instead of `getTextWithLearnLangInterpolation`, but it
// was too many unnecessary changes to do right now.
export default ({ translationText = '' }: { translationText: string }): JSX.Element => {
  const { learnLang } = useParams();

  return (
    <>
      { getTextWithLearnLangInterpolation(translationText, learnLang) }
    </>
  );
};
